import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
    /**
     * Recieves rows as data and save file as a speadsheet excel.
     *
     * @param data Rows array of data.
     * @param excelFileName File name for final export.
     * @param header Header rows to map data rows.
     */
    public exportAsExcelFile(data: any[], excelFileName: string, header?: any[]): void {
        const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, { header });
        const myworkbook: XLSX.WorkBook = { Sheets: { data: myworksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    /**
     * Writes buffer into file.
     *
     * @param buffer XLSX buffer write.
     * @param fileName File name of final export
     */
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
}
